import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import { HttpResponse } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';

@Injectable()
export class FileService {

  public static extractFileName(response: HttpResponse<Blob>): string {
    const contentDispositionHeader = response.headers.get('Content-Disposition');
    const regex = /^attachment; ?filename=(.*)/ig;
    const regexResult = regex.exec(contentDispositionHeader);

    return regexResult && regexResult[1] ? regexResult[1] : 'downloaded-file';
  }

  public static extractFileExtension(filename: string): string {
    const regex = /(\.[^.]+)$/ig;
    const regexResult = regex.exec(filename);

    return regexResult?.[1];
  }

  public saveToFileSystem(response: HttpResponse<Blob>): Observable<void> {
    const blob = new Blob([response.body], {type: 'text/plain'});
    FileSaver.saveAs(blob, FileService.extractFileName(response));
    return EMPTY;
  }
}
